'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetSetupForTests = exports.setupStyledComponents = undefined;

var _domReady = require('./domReady');

var _Dom = require('../utils/Dom');

var _BrowserTest = require('../utils/BrowserTest');

var SC_ATTR = 'data-hubspot-styled-components'; // Custom for our styled-components repackage

var hasSetupStyledComponents = false;
var oneTimeSetupStyledComponents = function oneTimeSetupStyledComponents() {
  if (hasSetupStyledComponents) return;
  var head = document.head;

  var anchorTag = head.querySelector('[data-hubspot-styled-components-anchor]');
  if (anchorTag != null) {
    head.removeChild(anchorTag);
    if ((0, _BrowserTest.ignoresStyleTagInsertionOrder)()) {
      // To fix a style precedence bug in IE11 and Edge < 17, we need to "re-insert" any
      // <link rel="stylesheet"> tags on the page (#5661).
      [head, document.body].forEach(function (container) {
        var styleTags = container.querySelectorAll('link[rel="stylesheet"], style:not([' + SC_ATTR + '])');
        [].slice.call(styleTags).forEach(function (styleTag) {
          var originalSheet = styleTag.sheet;
          container.appendChild(styleTag);
          var newSheet = styleTag.sheet;

          // Ensure that any styles that were inserted dynamically are carried over.
          if (!originalSheet || !originalSheet.rules || !newSheet || !newSheet.rules) return;
          if (newSheet.rules.length < originalSheet.rules.length) {
            for (var i = 0; i < originalSheet.rules.length; i++) {
              if (originalSheet.rules[i] !== newSheet.rules[i]) {
                newSheet.insertRule(originalSheet.rules[i].cssText, i);
              }
            }
          }
        });
      });
    }
    hasSetupStyledComponents = true;
    return;
  }

  var styledComponentsStylesTags = Array.prototype.slice.apply(head.querySelectorAll('style[' + SC_ATTR + ']'));
  var hasStyledComponentsTags = styledComponentsStylesTags.length > 0;

  // If the "anchor" tag wasn't found, we need to investigate.
  if (window.newrelic) {
    window.newrelic.addPageAction('notConfiguredForStyledComponents', {
      hasStyledComponentsTags: hasStyledComponentsTags
    });
  }

  // Move all styled-components <style> tags to the start of the <head>, preserving their order.
  styledComponentsStylesTags.reverse().forEach(function (tag) {
    head.removeChild(tag);
    (0, _Dom.prepend)(head, tag);
  });

  hasSetupStyledComponents = true;
};

var setupStyledComponents = exports.setupStyledComponents = function setupStyledComponents() {
  (0, _domReady.domReady)(function () {
    setTimeout(oneTimeSetupStyledComponents, 0); // Ensure that this method runs in its own tick
  });
};

var resetSetupForTests = exports.resetSetupForTests = function resetSetupForTests() {
  hasSetupStyledComponents = false;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/listeners/setupStyledComponents.js
// module id = 465
// module chunks = 2 3